import React  from "react";
import classes from "./ModalDialog.module.scss";

const ModalDialog = ({ className, ...props }) => {
  return (
    <div
      className={`${classes.wrapper} ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        // props.onClick;
      }}
      {...props}
    >
      {props.children}
    </div>
  );
};

export { ModalDialog };
